const origin = window.location.origin + "/";

// // Configuration des noms de couches
const layerNameMSCelAll = "cel_all_data";

// URLs de base
const urlFr = "https://map.electricite-locale.groupe-e.ch/";
const urlDe = "https://map.lokaler-strom.groupe-e.ch/";
// Styles de carte
const mapStyle = "mapbox://styles/mapboxgroupee/ckvqfg19mr18i14o8fs2iqw42";

// const swisstopoMapStyle =  "https://vectortiles.geo.admin.ch/styles/ch.swisstopo.basemap.vt/style.json";

const swisstopoMapStyle = "/basemap_custom_style.json";
const imageryBaseMap =
  "https://vectortiles.geo.admin.ch/styles/ch.swisstopo.imagerybasemap.vt/style.json";

// Token Mapbox
const mapboxAccessToken =
  "pk.eyJ1IjoibWFwYm94Z3JvdXBlZSIsImEiOiJjbTloNjQzMnowMWxsMm1zamFicjV5aXJsIn0.xGqvy9-1TvlDV3tP9LESQA";

// Couleurs
const selectedColor = "red";
const deselectedColor = "gray";

// Variables dynamiques selon la langue
let urlMVTCelAllGreE;
let lang, langmapbox, textSearch, titre, listeLangue, textComment, cardsButton;
let source, noData, fermer;
let date_text;

url_date = `${urlFr}api/vectortiles/communo/v1/rcpv?SERVICE=WFS&VERSION=2.0.0&REQUEST=getfeature&TYPENAME=${layerNameMSCelAll}&MAXFEATURES=1`;

url_api_health = `${urlFr}api/vectortiles/communo/v1/rcpv?mode=tile&layers=${layerNameMSCelAll}&tilemode=gmap&map.imagetype=mvt&tile=68107+46252+17.mvt`;

async function getGMLField() {
  try {
    const response = await fetch(url_date);
    const gmlText = await response.text();

    // Parser le GML
    const parser = new DOMParser();
    const xmlDoc = parser.parseFromString(gmlText, "application/xml");

    const field = xmlDoc.querySelector("DATE_CREAT");
    if (field) {
      date_text = field.textContent;
    } else {
    }
    return date_text;
  } catch (error) {
    console.error("Erreur :", error);
  }
}

// === SITE FRANÇAIS ===
if (origin === "https://map.electricite-locale.groupe-e.ch/") {
  urlMVTCelAllGreE = `${urlFr}api/vectortiles/communo/v1/rcpv?mode=tile&layers=${layerNameMSCelAll}&tilemode=gmap&map.imagetype=mvt&tile={x}+{y}+{z}.mvt`;

  lang = "FR";
  langmapbox = "fr-CH";

  textApiError=`⚠ Certains services sont momentanément indisponibles.
Les données peuvent être incomplètes.`

  textSearch = `
    <div class="card-body">
      <p class="card-text">Recherchez votre adresse</p>
      <div id="geocoder" class="geocoder"></div>
    </div>`;

  titre = "Recherche de périmètre du site de production";

  listeLangue = `
    <a class="pc-head-link dropdown-toggle arrow-none mr-0" href="${urlFr}" role="button"><strong>FR</strong></a> |
    <a class="pc-head-link dropdown-toggle arrow-none mr-0" href="${urlDe}" role="button">DE</a>`;

  textComment = `
    <div class="card-body">
      <h4>Bienvenue sur notre application de recherche de périmètre du site de production! 🌍</h4>
      <p>Pour commencer, suivez ces étapes simples&nbsp;:</p>
      <p><span class="step-number">1</span><strong>Recherchez votre adresse</strong> au format Rue, NPA Ville</p>
      <p><span class="step-number">2</span><strong>Sélectionnez le point</strong> correspondant sur la carte.</p>
      <p><span class="step-number">3</span><strong>Sélectionnez un type de périmètre</strong>.</p>
    </div>`;

  formchecklabeltxt = `Ne plus afficher cette fenêtre`;
  closelabeltxt = `J'ai compris`;

  cardsButton = `

<div class="card-body">
  <h5 class="card-title" style="display: flex; align-items: center; gap: 8px;">Choix du type de périmètre</h5>
  <div class="btn-group-vertical w-100" role="group" aria-label="Map style selection">
    <button type="button" class="btn  btn-outline-primary mb-2 active" id="CAButton">
      Communauté d'autoconsommation (CA) et RCP
    </button>
    <button type="button" class="btn btn-outline-primary mb-2" id="CEL40Button">
      Communauté d'électricité locale 40% (CEL40%)
    </button>
    <button type="button" class="btn btn-outline-primary mb-2" id="CEL20Button">
      Communauté d'électricité locale 20% (CEL20%)
    </button>
    <button type="button" class="btn btn-outline-primary" id="CELMTButton">
      Communauté d'électricité locale Moyenne Tension 40% (CEL MT40%)
    </button>
  </div>
    <hr class="my-4">
    
    <div class="card mt-3" style="width: 18rem;">
      <div class="card-body">
        <h5 class="card-title">Besoin de plus d'informations ?</h5>
        <p class="card-text">Découvrez tous les détails sur notre <a href="https://www.groupe-e.ch/fr/electricite/reseau/ca-rcp-cel" target="_blank" class="text-decoration-underline"> page explicative</a>.</p>
      </div>
    </div>
</div>





  `;

  source = `Source : Groupe E`;
  noData = "Pas de données disponible";
  fermer = "Fermer";

  getGMLField().then((date_text) => {
    // Do something with date_text
    const container = document.getElementById("date-container");
    if (container) {
      container.textContent = date_text
        ? `Dernière mise à jour des données : ${date_text}`
        : `Dernière mise à jour des données : inconnu`;
    }
  });

  document.getElementById("streetsLayerLabel").innerText = "Carte couleur";
  document.getElementById("satelliteLayerLabel").innerText = "Photo aérienne";
  document.getElementById("myCel20LayerLabel").innerText = "CEL sélectionnée";
  document.getElementById("myCelCommuneLayerLabel").innerText =
    "CEL dans ma commune";

  // === SITE ALLEMAND ===
} else {
  urlMVTCelAllGreE = `${urlDe}api/vectortiles/communo/v1/rcpv?mode=tile&layers=${layerNameMSCelAll}&tilemode=gmap&map.imagetype=mvt&tile={x}+{y}+{z}.mvt`;

  lang = "DE";
  langmapbox = "de-CH";
  textApiError=`⚠ Einige Dienste sind derzeit nicht verfügbar.
Die angezeigten Daten können unvollständig sein.`
  textSearch = `
    <div class="card-body">
      <p class="card-text">Finden Sie Ihre Adresse</p>
      <div id="geocoder" class="geocoder"></div>
    </div>`;

  titre = "Perimeter für lokal produzierten Strom";

  listeLangue = `
    <a class="pc-head-link dropdown-toggle arrow-none mr-0" href="${urlFr}" role="button">FR</a> |
    <a class="pc-head-link dropdown-toggle arrow-none mr-0" href="${urlDe}" role="button"><strong>DE</strong></a>`;

  textComment = `
    <div class="card-body">
      <h4>Willkommen bei unserem Tool für lokal produzierten Strom ! 🌍</h4>
      <p>Führen Sie diese einfachen Schritte aus&nbsp;:</p>
      <p><span class="step-number">1</span><strong>Suchen Sie nach Ihrer Adresse</strong> im Format Strasse, PLZ Stadt</p>
      <p><span class="step-number">2</span><strong>Wählen Sie den entsprechenden Punkt</strong> auf der Karte.</p>
      <p><span class="step-number">3</span><strong>Wählen Sie einen Perimetertyp aus</strong>.</p>
    </div>`;

  formchecklabeltxt = `Fenster nicht mehr anzeigen`;
  closelabeltxt = `Ich habe verstanden`;

  cardsButton = `

<div class="card-body">
  <h5 class="card-title">Auswahl des Perimeters für lokal produzierten Strom</h5>
  <div class="btn-group-vertical w-100" role="group" aria-label="Map style selection">
    <button type="button" class="btn  btn-outline-primary mb-2 active" id="CAButton">
      Eigenverbrauchsgemeinschaft (EVG) und ZEV
    </button>
    <button type="button" class="btn btn-outline-primary mb-2" id="CEL40Button">
      Die lokale Elektrizitätsgemeinschaft 40% (LEG40%)
    </button>
    <button type="button" class="btn btn-outline-primary mb-2" id="CEL20Button">
      Die lokale Elektrizitätsgemeinschaft 20% (LEG20%)
    </button>
    <button type="button" class="btn btn-outline-primary" id="CELMTButton">
      Lokale Elektrizitätsgemeinschaft Mittelspannungsanlagen  40% (LEG MS40%)
    </button>
  </div>
    <hr class="my-4">
    <div class="card mt-3" style="width: 18rem;">
      <div class="card-body">
        <h5 class="card-title">Weitere Informationen ?</h5>
        <p class="card-text">Entdecken Sie alle Details auf unserer <a href="https://www.groupe-e.ch/de/ihr-stromnetz/evg-zev-leg" target="_blank" class="text-decoration-underline"> Erklärungsseite</a>.</p>
      </div>
    </div>
</div>


  `;

  source = `Quelle : Groupe E`;
  noData = "Keine Angaben";
  fermer = "Schließen";

  getGMLField().then((date_text) => {
    // Do something with date_text
    const container = document.getElementById("date-container");
    if (container) {
      container.textContent = date_text
        ? `Letzte Aktualisierung der Daten : ${date_text}`
        : `Letzte Aktualisierung der Daten : inconnu`;
    }
  });

  document.getElementById("streetsLayerLabel").innerText = "Karte farbig";
  document.getElementById("satelliteLayerLabel").innerText = "Luftbilder";

  document.getElementById("myCel20LayerLabel").innerText = "Ausgewählte LEG";
  document.getElementById("myCelCommuneLayerLabel").innerText =
    "LEG in meiner Gemeinde";
}

document.addEventListener("DOMContentLoaded", function () {
  // Show popup if not hidden before
  if (!localStorage.getItem("hidePopup")) {
    document.getElementById("infoModal").style.display = "flex";
  } else {
    document.getElementById("infoModal").style.display = "none";
  }

  // Close button cross
  document
    .getElementById("closeBtnCoss")
    .addEventListener("click", function () {
      if (document.getElementById("dontShowCheckbox").checked) {
        localStorage.setItem("hidePopup", "true");
      }

      document.getElementById("infoModal").style.display = "none";
    });

  // Close button cross
  document.getElementById("dontShowBtn").addEventListener("click", function () {
    if (document.getElementById("dontShowCheckbox").checked) {
      localStorage.setItem("hidePopup", "true");
    }

    document.getElementById("infoModal").style.display = "none";
  });
});

// === Injection dans le DOM ===
document.getElementById("api-banner").innerHTML = textApiError;
document.getElementById("textSearch").innerHTML = textSearch;
document.getElementById("titre").innerHTML = titre;
document.getElementById("titre2").innerHTML = titre;
document.getElementById("listeLangue").innerHTML = listeLangue;
document.getElementById("listeLangue2").innerHTML = listeLangue;
document.getElementById("CardButton").innerHTML = cardsButton;
document.getElementById("textComment").innerHTML = textComment;

document.getElementById("dontShowBtn").innerText = closelabeltxt;
document.getElementById("formchecklabel").innerText = formchecklabeltxt;
